// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3jcj5","col":"styles_col__2qwXd"};